import React, { createRef } from "react";
import { Card, Flex, Heading, Text, Theme } from "@radix-ui/themes";
import { useBackgroundMachineSlideshow } from "../hooks/useBackgroundMachineSlideshow";

/**
 * This page is displayed when the application is initializing.
 *
 * It's intended to show a "loading" state while user authentication and
 * authorizations are established.
 *
 * This page does not rely on any router or authentication context, and is
 * fully self-contained with theme included.
 */
export default function LoadingView() {
  const ref = createRef<HTMLDivElement>();
  useBackgroundMachineSlideshow(ref);

  return (
    <>
      <style>
        {`
          html, body {
            margin: 0
          }
        `}
      </style>
      <Theme appearance="light">
        <Flex
          ref={ref}
          direction="column"
          align="center"
          justify="center"
          style={{
            backgroundImage: "url(https://smart.evueanywhere.com/images/background/pt-vario.webp)",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transition: "background-image 0.6s ease-in-out",
            height: "100vh",
            width: "100vw",
          }}
        >
          <Card size="4" style={{ width: 400 }}>
            <Heading as="h3" size="6" trim="start" mb="5">
              Loading
            </Heading>
            <Text as="div" size="2" weight="medium" mb="3">
              Please wait while we retrieve your data.
            </Text>
          </Card>
        </Flex>
      </Theme>
    </>
  );
}
